import { SvgIcon } from 'libs/ui/Icon';
import { SvgProps } from 'libs/ui/Icon/icons/types';
import { Colors } from 'libs/ui/theme';

export const ArrowRight = ({
  className,
  size = { width: 14, height: 14 },
  color = Colors.black,
}: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="10"
      viewBox="214 29 13 6"
      width="13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M223.376 33.6793C223.536 33.338 223.69 33.0393 223.84 32.7833C224 32.5273 224.154 32.314 224.304 32.1433H214.976V31.4713H224.304C224.154 31.29 224 31.0713 223.84 30.8153C223.69 30.5593 223.536 30.266 223.376 29.9353H223.936C224.608 30.714 225.312 31.29 226.048 31.6633V31.9513C225.312 32.314 224.608 32.89 223.936 33.6793H223.376Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);
